import { render, staticRenderFns } from "./CardOverview.vue?vue&type=template&id=04782403"
import script from "./CardOverview.vue?vue&type=script&lang=js"
export * from "./CardOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports